module.exports = __webpack_public_path__ + "static/media/forgot-password.988f3eed.svg";